import { render, staticRenderFns } from "./petitionList.vue?vue&type=template&id=3fce0311&scoped=true&"
import script from "./petitionList.vue?vue&type=script&lang=js&"
export * from "./petitionList.vue?vue&type=script&lang=js&"
import style0 from "./petitionList.vue?vue&type=style&index=0&id=3fce0311&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fce0311",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
